export default {
  submitLogin: '/authorize-service/guest/login',
  modifyPassword: '/authorize-service/authorize/service/user/modifyPassword',
  mpConfig: '/open-weixin-service/weixin/mp/oauth/mpConfig'
}



// WEBPACK FOOTER //
// ./src/config/login/index.js